var map = {
	"./favicon-src.png": 4694,
	"./gift.min.svg": 8340,
	"./trusticons-full.png": 245,
	"./trusticons-full@2x.png": 543,
	"./trusticons-small.png": 265,
	"./trusticons-small@2x.png": 1659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4788;